import {
  getBranchCoupons,
  getCouponCode
} from "../api/bernabeu";

import {
  callTypes,
  couponSlice
} from "../../redux/reducers/couponSlice";

const { actions } = couponSlice;

const fetchBranchCoupons = (branch, sellingType, sellingModality, date: any = null) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  getBranchCoupons(branch, sellingType, sellingModality, date).then((response: any) => {
    dispatch(actions.setBranchCoupons({
      entities: response.data
    }));
  }).catch((error) => {
    console.log('fetchBranchCoupons falhou:');
    console.log({error});

    dispatch(actions.setBranchCoupons({
      entities: []
    }));
  });
}

const fetchCouponCode = (branch, code, sellingType: string, sellingModality: string, date: string = '') => dispatch => {
  return new Promise((resolve, reject) => {
    const params: any = {
      selling_type: sellingType,
      selling_modality: sellingModality,
    };

    if (date) {
      params.date = date;
    }

    getCouponCode(branch, code, params).then((response: any) => {
      resolve(response.data);
    }).catch((error) => {
      console.log('fetchCouponCode falhou:');
      console.log({error});

      reject(error);
    });
  });
}

export {
  fetchBranchCoupons,
  fetchCouponCode
};
